export const formatDate = (isoString, showTime = true) => {
  if (!isoString) return null;

  if (isNaN(new Date(isoString).getTime())) {
    return formatEvent(isoString);
  }

  const [datePart, timePart] = isoString.split('T');
  const [year, month, day] = datePart.split('-');

  let result = `${day}/${month}/${year}`;

  if (showTime && timePart) {
    const [hour, minute] = timePart.split(':');
    result += ` ${hour}:${minute}`;
  }

  return result;
};

export const formatNumber = (numero, casasDecimais = 2, sigla = false) => {
  if (numero === null) return null;

  const options = {
    minimumFractionDigits: casasDecimais,
    maximumFractionDigits: casasDecimais,
    style: 'decimal',
  };

  if (!sigla) {
    return new Intl.NumberFormat('pt-BR', options).format(numero);
  }

  return sigla + ' ' + new Intl.NumberFormat('pt-BR', options).format(numero);
};

export const formatValue = (valor, tipo, casasDecimais = null) => {
  switch (tipo) {
    case 'date':
    case 'datetime':
    case 'timestamp':
      return formatDate(valor);
    case 'decimal':
      return formatNumber(valor, casasDecimais);
    default:
      return valor;
  }
};

export const onlyNumbers = (data) => {
  return data.replace(/[^0-9]/g, '');
};

const formatEvent = (valor) => {
  if (valor.trim().startsWith('{')) {
    return JSON.parse(valor).status;
  }

  return valor;
};
